import { render, staticRenderFns } from "./EditPurchaseDocumentPage.vue?vue&type=template&id=1e8f4d9e&scoped=true"
import script from "./EditPurchaseDocumentPage.vue?vue&type=script&lang=js"
export * from "./EditPurchaseDocumentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8f4d9e",
  null
  
)

export default component.exports